import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/**
 * LAS FOTOS CON LAS QUE EL TÉCNICO CERRÓ EL DÍA.
 *
 * No son las de la visita —esas son el «antes», y viven en la orden de
 * servicio—: son las que subió al marcar salida o al reportar un avance, y son
 * la prueba de lo que quedó hecho.
 *
 * Hacían falta aquí porque quien cierra la orden le está pidiendo al cliente
 * que firme conformidad, y hasta ahora lo hacía sin ver una sola foto ni leer
 * lo que el técnico reportó. Firmar a ciegas lo que otro dice que hizo es
 * justo lo que un acta no debería permitir.
 *
 * El bucket es privado, así que la ruta se cambia por una firma temporal, igual
 * que en las fotos de la visita.
 */

const BUCKET = 'evidencias'

export type FotoDelTrabajo = {
  id: string
  ruta: string
  creado_en: string
  url: string | null
}

export function useFotosDelTrabajo(ordenTrabajoId: string | null) {
  return useQuery({
    queryKey: ['fotos-orden-trabajo', ordenTrabajoId],
    enabled: Boolean(ordenTrabajoId),
    staleTime: 50 * 60 * 1000,
    queryFn: async (): Promise<FotoDelTrabajo[]> => {
      if (!ordenTrabajoId) return []

      const { data, error } = await supabase
        .from('fotos_orden_trabajo')
        .select('id, ruta, creado_en')
        .eq('orden_trabajo_id', ordenTrabajoId)
        .order('creado_en')

      if (error) throw new Error(mensajeDeError(error))

      const filas = (data ?? []) as { id: string; ruta: string; creado_en: string }[]
      if (filas.length === 0) return []

      // Una sola llamada para todas: firmar de a una deja la rejilla apareciendo
      // a pedazos.
      const { data: firmas } = await supabase.storage
        .from(BUCKET)
        .createSignedUrls(filas.map((f) => f.ruta), 3600)

      return filas.map((f, i) => ({ ...f, url: firmas?.[i]?.signedUrl ?? null }))
    },
  })
}
